stimulusApp.register(
  "faq-categories",
  class extends Stimulus.Controller {
    static targets = ["nav", "button", "panel"]

    connect() {
      this.navTarget.hidden = false
      this.#show(0)
    }

    select({ params: { index } }) {
      this.#show(index)
    }

    #show(index) {
      this.buttonTargets.forEach((button, buttonIndex) => {
        button.setAttribute("aria-pressed", buttonIndex === index)
      })
      this.panelTargets.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== index
      })
    }
  },
)
